import { LearningItem } from '../../models/LearningItem'

export default function learningSuggestions(userLearningItems: LearningItem[]) {
  return userLearningItems
    .filter(
      ({ userLearningAssignments, learningProgress }) =>
        userLearningAssignments?.length &&
        !userLearningAssignments?.some(({ dueDate }) => dueDate) &&
        !learningProgress?.firstAccessedAt
    )
    .map((learningItem) => learningItem)
}
